import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CommonModalComponent} from '../../../../shared/common-modal/common-modal.component';
import {TranslationService} from '../../../shared';
import {TranslateService} from '@ngx-translate/core';
import {SessionStorage} from 'ngx-webstorage';
import {User} from '../../../../shared/user/user';
import {Range} from '../../../../shared/model/range-model';
import {OdmAddModalComponent} from '../../shared/odm-add-modal/odm-add-modal.component';
import {
  CubicleOption,
  CubicleOptionValue,
  EditOptionValuePayload
} from '../../../../shared/model/cubicleOption-model';
import {OptionsService} from "../../../../shared/services/options.service";


@Component({
  standalone: false,
  selector: 'app-odm-edit-option-value-modal',
  templateUrl: './odm-edit-option-value-modal.component.html',
  styleUrls: ['./odm-edit-option-value-modal.component.less']
})
export class OdmEditOptionValueModalComponent {

  @Input()
  selectedRange: Range;

  @Input()
  options: CubicleOption[];

  @Output()
  saveOptionValue: EventEmitter<EditOptionValuePayload> = new EventEmitter<EditOptionValuePayload>();

  @ViewChild('editOptionValueModal', {static: false}) editOptionValueModal: CommonModalComponent;
  @ViewChild('addReferenceModal', {static: false}) addReferenceModal: OdmAddModalComponent;

  @SessionStorage()
  public user: User;

  availableOptions: any[];
  editOptionValueForm: EditOptionValuePayload = {optionId: '', optionNameKey: '', rangeId: '', name: {}, description: {}};
  notAllowedReferenceCategoriesForOptions: string[];
  editedOptionName: string;
  editedOptionValueName: string;
  isLoading: boolean = false;

  constructor(private optionsService: OptionsService,
              private translationService: TranslationService,
              private translateService: TranslateService) {
  }


  showAddMode() {
    this.editOptionValueForm = {optionId: '', optionNameKey: '', rangeId: this.selectedRange.id, name: {}, description: {}};

    this.editedOptionName = '';
    this.availableOptions = []

    this.options.forEach(option => this.availableOptions.push({
      name: option.name,
      nameTranslated: this.translateService.instant(option.name),
      id: option.id
    }));
    this.translationService.getAllLanguagesByCountry(this.user.partnerCountry).subscribe(languages => {
      languages.forEach(lang => {
        this.editOptionValueForm.name[lang] = '';
        this.editOptionValueForm.description[lang] = '';
      })
    })
    this.setAllowedCategories();

    this.editOptionValueModal.show();
  }

  showEditMode(option: CubicleOption, optionValue: CubicleOptionValue) {
    this.editOptionValueForm = {optionId: option.id, optionNameKey: '', rangeId: this.selectedRange.id, name: {}, description: {}, valueId: optionValue.value};
    this.editedOptionName = option.name;
    this.editedOptionValueName = optionValue.value;

    if (optionValue.reference) {
      this.editOptionValueForm.bslReference = optionValue.reference.ref;
    }

    this.translationService.getLocalesOfCountryOfKey(optionValue.value.toString()).subscribe(locale => {
      locale.forEach(loc => {
        this.editOptionValueForm.name[loc.language] = loc.translations[0].translation;
      })
    });

    this.translationService.getLocalesOfCountryOfKey(optionValue.reference.description.toString()).subscribe(locale => {
      locale.forEach(loc => {
        this.editOptionValueForm.description[loc.language] = loc.translations[0].translation;
      })
    });

    this.setAllowedCategories();

    this.editOptionValueModal.show();
  }

  hide() {
    this.editOptionValueModal.hide();
  }

  isValidForm(): boolean {
    if (!this.editOptionValueForm.name ||
      !this.editOptionValueForm.description) {
      return false;
    }

    for (let key in this.editOptionValueForm.name) {
      if (!this.editOptionValueForm.name[key]) {
        return false;
      }
    }
    for (const key in this.editOptionValueForm.description) {
      if (!this.editOptionValueForm.description[key]) {
        return false;
      }
    }
    return true;
  }

  clickOnSaveOptionValue() {

    let selectedOption;
    let editPayload: EditOptionValuePayload;

    if (this.availableOptions !== undefined && this.availableOptions !== null && this.availableOptions.length > 0) {
      selectedOption = this.availableOptions.find(opt => opt.name === this.editOptionValueForm.optionNameKey);
      editPayload = {
        optionId: selectedOption.id,
        name: this.editOptionValueForm.name,
        description: this.editOptionValueForm.description,
        rangeId: this.selectedRange.id,
        bslReference: this.editOptionValueForm.bslReference,
        optionNameKey: selectedOption.name};

    } else {
      editPayload = {
        optionId: this.editOptionValueForm.optionId,
        name: this.editOptionValueForm.name,
        description: this.editOptionValueForm.description,
        rangeId: this.selectedRange.id,
        bslReference: this.editOptionValueForm.bslReference,
        optionNameKey: this.editedOptionName,
        optionValueNameKey: this.editedOptionValueName};
    }
    this.saveOptionValue.emit(editPayload);
  }

  clickAddReferenceButton() {
    this.addReferenceModal.show();
  }

  addReference(event: any) {
    this.editOptionValueForm.bslReference = event.bslReference.reference;
    this.isLoading = true
    this.optionsService.getOptionDescriptionTranslations(this.selectedRange.id, event.bslReference.reference).subscribe(translations => {
      this.editOptionValueForm.name = translations[0].translations;
      this.editOptionValueForm.description = translations[1].translations;
      this.isLoading = false;
    });
  }

  clickDeleteReferenceButton() {
    this.editOptionValueForm.bslReference = null;
    this.isLoading = true
    this.translationService.getAllLanguagesByCountry(this.user.partnerCountry).subscribe(languages => {
      languages.forEach(lang => {
        this.editOptionValueForm.name[lang] = '';
        this.editOptionValueForm.description[lang] = '';
        this.isLoading = false;
      });
    });
  }

  // function for the ngfor + ngmodel, so it doesn't lose focus

  trackByFn(index, item): number {   return index; }

  private setAllowedCategories() {
    this.notAllowedReferenceCategoriesForOptions = [
      'Cubicle',
      'Transformers',
      'Switchboard',
      'Three Functions',
      'Single Function',
      'Ring Main Unit',
      'Commercial reference',
      'Generic References',
      'Commercial References'];
  }

}
